
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Swiftdzireonrentinnavimumbai() {



const cardData = {
  keyword: "Swift Dzire on Rent in Navi Mumbai",
  heading: "Skyline Cabs: Swift Dzire on Rent in Navi Mumbai",
  headingDescription: "Skyline Cabs provides premium Swift Dzire on Rent in Navi Mumbai for city travel, airport transfers, corporate movement, and outstation trips. The Swift Dzire is one of the most preferred sedan vehicles due to its fuel efficiency, smooth ride quality, and comfortable seating. Whether you require short-distance city rides, full-day bookings, or long-distance highway travel, our fleet ensures reliability and punctual service. With professional drivers, clean interiors, transparent pricing, and 24x7 availability, Skyline Cabs guarantees a stress-free and comfortable rental experience across Navi Mumbai and Mumbai.",

  top: "Top Places to Visit in Navi Mumbai with Swift Dzire Rental",

  topPlaces: [
    {
      title: "Central Park Kharghar",
      description: "Central Park Kharghar is one of the largest and most beautifully planned urban parks in Navi Mumbai, offering lush greenery, jogging tracks, fountains, and open recreational areas. Families and corporate visitors frequently choose this destination for relaxation and outdoor activities. The well-maintained roads leading to Central Park make Swift Dzire rental Navi Mumbai an ideal choice for comfortable city travel. Visitors can enjoy peaceful morning walks, photography sessions, and cultural events hosted in the amphitheater. Skyline Cabs ensures timely drop and pickup for a seamless travel experience."
    },
    {
      title: "Palm Beach Road",
      description: "Palm Beach Road is famous for its smooth infrastructure and scenic coastal drive connecting Vashi to Belapur. The route offers breathtaking sunset views and clean, wide roads perfect for sedan travel. Swift Dzire on rent with driver Navi Mumbai allows passengers to enjoy relaxed evening drives without traffic stress. The road is also preferred for airport transfers and business travel due to its connectivity."
    },
    {
      title: "Belapur Fort",
      description: "Belapur Fort is a historical monument offering panoramic views of Navi Mumbai and surrounding creeks. It attracts history enthusiasts and trekking lovers throughout the year. Swift Dzire car rental Navi Mumbai ensures smooth access to this elevated location with comfortable seating and air conditioning."
    },
    {
      title: "Seawoods Grand Central Mall",
      description: "Seawoods Grand Central Mall is a premium shopping and entertainment destination offering multiplex cinemas, dining outlets, and retail brands. Renting Swift Dzire taxi service Navi Mumbai provides convenient family transportation to this popular hub."
    },
    {
      title: "Pandavkada Waterfalls",
      description: "Pandavkada Waterfalls is a scenic monsoon attraction located near Kharghar hills. The peaceful environment and natural beauty attract families and nature enthusiasts. Swift Dzire rental service Navi Mumbai ensures safe and comfortable group travel."
    },
    {
      title: "DY Patil Stadium",
      description: "DY Patil Stadium hosts major sports and entertainment events in Navi Mumbai. Swift Dzire airport drop Navi Mumbai service is often combined with event travel planning for timely transportation."
    },
    {
      title: "Karnala Bird Sanctuary",
      description: "Karnala Bird Sanctuary is a perfect weekend getaway for nature lovers. Swift Dzire hire in Navi Mumbai ensures smooth highway travel with comfortable seating."
    },
    {
      title: "Nerul Balaji Temple",
      description: "Nerul Balaji Temple offers peaceful spiritual ambiance and beautiful architecture. Families prefer Swift Dzire on rent in Navi Mumbai for comfortable temple visits."
    },
    {
      title: "Rock Garden Nerul",
      description: "Rock Garden provides calm sea-facing views and walking paths ideal for evening outings. Swift Dzire rental Navi Mumbai ensures relaxed family travel."
    },
    {
      title: "Utsav Chowk",
      description: "Utsav Chowk is a vibrant landmark known for its European-style architecture and lively surroundings. Swift Dzire taxi service Navi Mumbai provides smooth city connectivity."
    }
  ],

  services: [
    {
      name: "swift dzire on rent in mumbai",
      description: "Skyline Cabs offers swift dzire on rent in mumbai for city rides, corporate meetings, and airport transfers. The sedan is known for fuel efficiency, smooth suspension, and comfortable seating for up to four passengers. Ideal for daily travel and business movement, this service includes professional chauffeurs, clean interiors, and transparent pricing."
    },
    {
      name: "swift dzire on rent in navi mumbai",
      description: "Our swift dzire on rent in navi mumbai service provides reliable and affordable transportation across residential and commercial sectors. With flexible booking duration and punctual drivers, customers enjoy stress-free city travel."
    },
    {
      name: "swift dzire rental navi mumbai",
      description: "Swift dzire rental navi mumbai includes hourly, daily, and outstation packages. The vehicle ensures comfortable seating, efficient air conditioning, and smooth driving experience."
    },
    {
      name: "swift dzire hire in navi mumbai",
      description: "Choose swift dzire hire in navi mumbai for business travel, airport pickup, and local commuting. Skyline Cabs guarantees punctual service and well-maintained vehicles."
    },
    {
      name: "swift dzire car rental navi mumbai",
      description: "Swift dzire car rental navi mumbai is ideal for families and professionals requiring economical yet comfortable sedan transport."
    },
    {
      name: "swift dzire taxi service navi mumbai",
      description: "Professional swift dzire taxi service navi mumbai ensures smooth city rides and airport transfers with verified drivers."
    },
    {
      name: "book swift dzire on rent in navi mumbai",
      description: "Easily book swift dzire on rent in navi mumbai through secure online platform with instant confirmation."
    },
    {
      name: "best swift dzire on rent navi mumbai",
      description: "Recognized as best swift dzire on rent navi mumbai for reliable service, punctuality, and comfort."
    },
    {
      name: "cheapest swift dzire rental navi mumbai",
      description: "Affordable cheapest swift dzire rental navi mumbai packages without compromising quality."
    },
    {
      name: "swift dzire on rent with driver navi mumbai",
      description: "Chauffeur-driven swift dzire on rent with driver navi mumbai ensures stress-free travel."
    },
    {
      name: "swift dzire rental service navi mumbai",
      description: "Flexible swift dzire rental service navi mumbai designed for daily and outstation travel."
    },
    {
      name: "swift dzire airport pickup navi mumbai",
      description: "Timely swift dzire airport pickup navi mumbai with flight tracking support."
    },
    {
      name: "swift dzire airport drop navi mumbai",
      description: "Reliable swift dzire airport drop navi mumbai ensuring punctual departure."
    }
  ],
tableData: [
  ["swift dzire on rent in mumbai", "swift dzire on rent in navi mumbai"],
  ["swift dzire rental navi mumbai", "swift dzire hire in navi mumbai"],
  ["swift dzire car rental navi mumbai", "swift dzire taxi service navi mumbai"],
  ["book swift dzire on rent in navi mumbai", "best swift dzire on rent navi mumbai"],
  ["cheapest swift dzire rental navi mumbai", "swift dzire on rent with driver navi mumbai"],
  ["swift dzire rental service navi mumbai", "swift dzire airport pickup navi mumbai"],
  ["swift dzire airport drop navi mumbai", ""]
],

  whychoose: [
    {
      WhyChooseheading: "Fuel Efficient & Economical Sedan",
      WhyChoosedescription: "Swift Dzire offers excellent mileage making it cost-effective for city and airport travel."
    },
    {
      WhyChooseheading: "Professional Drivers",
      WhyChoosedescription: "Verified chauffeurs ensure safe and punctual travel experience."
    },
    {
      WhyChooseheading: "Transparent Pricing",
      WhyChoosedescription: "Clear fare breakdown without hidden charges."
    },
    {
      WhyChooseheading: "24x7 Availability",
      WhyChoosedescription: "Round-the-clock booking support for urgent travel needs."
    },
    {
      WhyChooseheading: "Clean & Maintained Vehicles",
      WhyChoosedescription: "Regular servicing and sanitization ensure hygiene."
    },
    {
      WhyChooseheading: "Airport Expertise",
      WhyChoosedescription: "Dedicated airport pickup and drop support."
    },
    {
      WhyChooseheading: "Flexible Booking Options",
      WhyChoosedescription: "Hourly, full-day, and outstation rental packages."
    },
    {
      WhyChooseheading: "Customer-Focused Service",
      WhyChoosedescription: "Dedicated support team ensures smooth booking and ride experience."
    }
  ]
}


const faqData = [
    {
        id: 1,
        question: 'How can I book Swift Dzire on Rent in Navi Mumbai with Skyline Cabs?',
        answer:
            'Booking Swift Dzire on Rent in Navi Mumbai with Skyline Cabs is quick and hassle-free. Simply visit our website or mobile app, select Swift Dzire from the vehicle options, enter your pickup and drop location, choose your preferred date and time, and confirm your booking instantly. You will receive immediate confirmation along with driver and vehicle details for complete transparency.',
    },
    {
        id: 2,
        question: 'What is the fare for Swift Dzire on Rent in Navi Mumbai?',
        answer:
            'The fare for Swift Dzire on Rent in Navi Mumbai depends on the type of trip such as local, airport transfer, or outstation travel. Skyline Cabs offers competitive and transparent pricing with no hidden charges. The final fare is displayed clearly before booking confirmation so you know exactly what you are paying.',
    },
    {
        id: 3,
        question: 'Is Swift Dzire suitable for local travel in Navi Mumbai?',
        answer:
            'Yes, Swift Dzire is one of the most preferred cars for local city travel in Navi Mumbai. It offers comfortable seating for up to 4 passengers, smooth suspension for city roads, and excellent fuel efficiency. It is ideal for office commutes, shopping trips, and daily travel needs.',
    },
    {
        id: 4,
        question: 'Can I book Swift Dzire for airport transfers?',
        answer:
            'Absolutely. Skyline Cabs provides Swift Dzire on Rent in Navi Mumbai for airport pickup and drop services. The car offers sufficient luggage space and comfortable seating, making airport transfers convenient and affordable.',
    },
    {
        id: 5,
        question: 'Is Swift Dzire available for outstation trips from Navi Mumbai?',
        answer:
            'Yes, Swift Dzire on Rent in Navi Mumbai is available for outstation trips to Pune, Lonavala, Nashik, Shirdi, Mahabaleshwar, and more. It is an economical and comfortable option for long-distance travel.',
    },
    {
        id: 6,
        question: 'Is online payment available for Swift Dzire booking?',
        answer:
            'Yes, Skyline Cabs supports secure online payments including UPI, debit cards, credit cards, and net banking. You receive instant booking confirmation once payment is completed successfully.',
    },
    {
        id: 7,
        question: 'Can I pre-book Swift Dzire in Navi Mumbai?',
        answer:
            'Yes, you can pre-book Swift Dzire on Rent in Navi Mumbai for weekends, holidays, corporate travel, or personal trips. Advance booking ensures guaranteed availability and better travel planning.',
    },
    {
        id: 8,
        question: 'Is driver included with Swift Dzire rental?',
        answer:
            'Yes, every Swift Dzire rental with Skyline Cabs includes a professional and experienced driver. Our chauffeurs are trained, courteous, and familiar with Navi Mumbai routes and highways.',
    },
    {
        id: 9,
        question: 'Is Swift Dzire on Rent in Navi Mumbai available 24/7?',
        answer:
            'Yes, Skyline Cabs offers 24/7 Swift Dzire rental service in Navi Mumbai. Whether you need early morning travel or late-night pickup, our service is available round the clock.',
    },
    {
        id: 10,
        question: 'Why choose Skyline Cabs for Swift Dzire on Rent in Navi Mumbai?',
        answer:
            'Skyline Cabs is trusted for Swift Dzire on Rent in Navi Mumbai because we provide clean vehicles, professional drivers, transparent pricing, punctual service, and 24x7 customer support. We focus on delivering affordable, comfortable, and reliable travel experiences every time.',
    },
];

const someReviews = [
    {
        name: "Mr. Nitin Sharma",
        rating: 5,
        review: "Booked Swift Dzire on Rent in Navi Mumbai for airport transfer. The car was clean, driver was punctual, and the ride was smooth and comfortable. Excellent service from Skyline Cabs!"
    },
    {
        name: "Ms. Richa Patil",
        rating: 4,
        review: "Very affordable Swift Dzire rental in Navi Mumbai. Transparent pricing and professional driver. Skyline Cabs provides reliable and stress-free travel service."
    },
];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



      
    
      const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Swift Dzire on Rent in Navi Mumbai",
  "image": "https://skylinecabs.com/assets/images/swift-dzire-rent-navi-mumbai.jpg",
  "description": "Rent Swift Dzire in Navi Mumbai with Skyline Cabs for airport transfers, local travel, and outstation trips. Affordable and reliable Swift Dzire rental with driver available 24x7 across Vashi, Nerul, Kharghar, and Panvel.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8043"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "999",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/swift-dzire-on-rent-navi-mumbai"
  }
};



    return (
        <div>


<Helmet>
  <title>Swift Dzire on Rent in Navi Mumbai | Taxi & Outstation Rental | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Rent Swift Dzire in Navi Mumbai with Skyline Cabs for airport pickup, drop, local and outstation trips. Reliable 24x7 service with professional drivers across Vashi, Nerul, Kharghar, and Panvel." 
  />
  <meta 
    name="keywords" 
    content="swift dzire on rent in mumbai, swift dzire on rent in navi mumbai, swift dzire rental navi mumbai, swift dzire hire in navi mumbai, swift dzire car rental navi mumbai, swift dzire taxi service navi mumbai, book swift dzire on rent in navi mumbai, best swift dzire on rent navi mumbai, cheapest swift dzire rental navi mumbai, swift dzire on rent with driver navi mumbai, swift dzire rental service navi mumbai, swift dzire airport pickup navi mumbai, swift dzire airport drop navi mumbai, swift dzire outstation rental navi mumbai, swift dzire cab for outstation navi mumbai, swift dzire on rent in vashi, swift dzire on rent in nerul, swift dzire on rent in kharghar, swift dzire on rent in panvel, Skyline Cabs Swift Dzire Navi Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/148.jpeg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Swiftdzireonrentinnavimumbai;